import { NotificationModel } from '../../../../../common/notifications/Notifications.model';
import {
  createSelector,
  IContactUsState,
  ISharedState,
  IUserNotice,
  IUserNoticeState,
} from '../../../../models/reduxState';
import { contactStateSelector } from '../../../app/selectors/contactUsSelector';

export const sharedStateSelector = createSelector(contactStateSelector, (r: IContactUsState) => r.SharedState);

export const regionInfoSelector = createSelector(sharedStateSelector, (r: ISharedState) => r.regionInfo);

export const userNoticesSelector = createSelector(contactStateSelector, (c: IContactUsState) => c.UserNoticeState);

export const notificationsSelector = createSelector(userNoticesSelector, (u: IUserNoticeState) => {
  return u.userNotices.map<NotificationModel>((notice: IUserNotice) => ({
    id: notice.noticeId,
    content: notice.noticeText,
    isDismissed: notice.isDismissed,
  }));
});

export const useAnnouncementFloatSelector = createSelector(
  sharedStateSelector,
  (r: ISharedState) => r.useAnnouncementFloat
);
